<style scoped lang="less">
.flexx {
	display: flex;
	align-items: center;
}
body {
	height: auto;
}

.classtrainstop {
	height: 5rem;
	padding: 1rem;
	border: 1px solid #ccc;
	border-radius: 5px;
	background-color: #3065bc;
	div {
		margin-right: 1rem;
	}
}

.classtitle {
	margin-top: 1rem;
	width: 100%;
	background-color: #fff;
	box-sizing: border-box;
	padding: 1rem 1rem 0 1rem;

	.classstebox {
		position: absolute;
		top: 10px;
		right: 10px;
		width: 20%;
	}

	.classtitle1 {
		width: 50%;
		margin-top: 20px;
		margin-left: 1.2rem;

		.classtitle1nem {
			font-size: 1.6rem;
			margin-bottom: 15px;
		}

		div {
			font-size: 1rem;
			p {
				margin-right: 40px;
			}
		}
	}
	.classtitle2 {
		width: 20%;
		position: absolute;
		right: 0%;
		bottom: 1%;
	}
	.classnametiltle {
		width: 20%;
		font-size: 2rem;
		margin-bottom: 4rem;
		position: absolute;
		left: 50%;
		transform: translateX(-50%);
	}

	.tablists {
		margin-top: 1rem;
		padding: 1rem 1rem 0 1rem;
		border-top: 1px solid #ccc;

		div {
			width: 16%;
			text-align: center;
			height: 2.4rem;
			font-size: 1.2rem;
			cursor: pointer;
		}

		.actives {
			color: #3399ff;
			border-bottom: 4px solid #3399ff;
		}
	}
}

.classdatatotle {
	margin: 1rem 0;
	padding: 1rem;
	background-color: #fff;

	.trainstitle {
		padding-bottom: 10px;
		border-bottom: 1px solid #ccc;
	}

	.trainschat {
		margin-top: 1rem;
		justify-content: space-between;
		.trainschat1 {
			width: 33.3%;
			margin: 0 3rem;
			p {
				margin: 10px;
				font-size: 1rem;
			}
		}

		.trainschat2 {
			width: 33.3%;
			p {
				margin: 10px;
				font-size: 1rem;
			}
		}
	}
}

.responstbilteall {
	.rebuilctlischat {
		width: 40%;
		height: 28rem;
		// border: 1px solid #ff5c00;
		margin-top: 1rem;
	}

	.rebuilctlistdata {
		width: 90%;
		flex-wrap: wrap;
		margin-left: 3rem;
		.rebuilctlistdataitme {
			width: 48%;
			margin: 1rem 1%;
			border: 1px solid #d9d9d9;
			border-radius: 8px;
			box-sizing: border-box;
			padding: 10px;
			align-items: flex-start;
			height: 12rem;
			overflow: hidden;

			.cilcle {
				width: 60px;
				height: 60px;
				border-radius: 50%;
				display: flex;
				align-items: center;
				justify-content: center;
				border: 1px solid;
				margin-right: 10px;
				background-color: #81d3f8;
				color: #fff;
				font-size: 1.8rem;
			}

			.stdataitmefont {
				.stdataitmecontent {
					width: 90%;
					font-size: 1rem;
					padding: 0 10px;
					box-sizing: border-box;
				}
				p {
					font-size: 20px;
					margin-bottom: 1rem;
					white-space: break-spaces;
				}
			}
		}
	}
}

.responstbilteall {
	.classreabilct {
		height: 30rem;
		width: 100%;
	}
}

.classreabilctexr {
	height: 70vh;
	padding: 1rem 0;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
	overflow-y: scroll;
}

.responsbilict {
	height: 22rem;
	// padding: 1rem 0;
}

.traintimers {
	height: 22rem;
}

/* 修改滚动条的宽度、颜色和圆角 */
.classreabilctexr::-webkit-scrollbar {
	width: 10px;
	height: 10px;
	background-color: #f5f5f5;
	border-radius: 5px;
}
/* 修改滚动条滑块的样式 */
.classreabilctexr::-webkit-scrollbar-thumb {
	background-color: #1abc9c;
	border-radius: 5px;
}
/* 鼠标悬停时修改滑块的样式 */
.classreabilctexr::-webkit-scrollbar-thumb:hover {
	background-color: #a8a8a8;
}
/* 滚动条上方和下方的按钮样式 */
.classreabilctexr::-webkit-scrollbar-button {
	display: none;
}

.el-empty {
	height: 100% !important;
}

.scoolct {
	height: 28rem;
	/deep/ .el-carousel {
		height: 100%;
		.el-carousel__container {
			position: inherit !important;
			height: 100% !important;
		}
	}
}

/* 滚动条整体样式 */
.scoolct::-webkit-scrollbar {
	width: 10px; /* 宽度 */
	height: 10px; /* 高度 */
}
/* 滚动槽 */
.scoolct::-webkit-scrollbar-track {
	background-color: #fff; /* 背景色 */
	border-radius: 5px; /* 圆角 */
}
/* 滚动条滑块 */
.scoolct::-webkit-scrollbar-thumb {
	background-color: #48da6a; /* 背景色 */
	border-radius: 5px; /* 圆角 */
}
/* 滚动条滑块悬停样式 */
.scoolct::-webkit-scrollbar-thumb:hover {
	background-color: #fff; /* 背景色 */
}

.staprelist {
	margin: 0 auto;
	width: 20%;
	padding: 20px;
	border-radius: 100px;
	cursor: pointer;
}
</style>
<template>
	<div ref="homes">
		<titles titlename="我的实训档案" titlecontent="这里可以看到我的实训档案" :mbx="paths"></titles>

		<div id="pdf-container" style="width: 100%;">
			<div class="classtitle">
				<div class="flexx" style="position: relative;">
					<div class="classstebox">
						<el-select v-model="stevalue" placeholder="请选择设备" style="width:80%;height:40px;">
							<el-option v-for="item in stenamelist" :key="item.sx_te_guid" :label="item.te_deviceName" :value="item.sx_te_guid"></el-option>
						</el-select>
					</div>
					<img style="margin-left: 1rem;width: 100px;height: 100px;border-radius: 50%;" src="@/images/header.jpg" alt="" />
					<div class="classtitle1">
						<p class="classtitle1nem">{{ usersobj.ui_realName }}</p>
						<div class="classnos">
							<div class="flexx">
								<p>学号：{{ usersobj.ui_joyNumber ?? '' }}</p>
								<p>所属专业：{{ usersobj.ProName }}</p>
							</div>
							<div class="flexx">
								<p :title="usersobj.ClaName ?? '暂无班级'">班级：{{ usersobj.ClaName }}</p>
								<p :title="usersobj.SchoolName ?? '暂无院校'">所属院校：{{ usersobj.SchoolName }}</p>
							</div>
						</div>
					</div>
					<p class="classnametiltle">学员实训档案</p>
					<div class="classtitle2" v-show="ispdfs">
						<el-button icon="el-icon-edit" v-print="printsobj">打印</el-button>
						<el-button icon="el-icon-download" @click="downloadPDF(1)">下载</el-button>
					</div>
				</div>
				<div class="tablists flexx">
					<div ref="scrollTotablists1" :class="{ actives: isactives == 1 }" @click="changetablist(1)">实训数据统计</div>
					<div ref="scrollTotablists2" :class="{ actives: isactives == 2 }" @click="changetablist(2)">综合能力评估</div>
					<div ref="scrollTotablists3" :class="{ actives: isactives == 3 }" @click="changetablist(3)">实训记录</div>
				</div>
			</div>

			<div class="classdatatotle">
				<div class="trainstitle flexx">
					<span style="display: block;width: 6px;height: 20px;margin-right: 10px;border-radius: 2px;background-color: #58A3F7;"></span>
					<p style="font-size: 1.2rem;font-weight: 600;">实训数据统计</p>
				</div>
				<div class="trainschat flexx">
					<div class="trainschat1 flexx">
						<img src="@/images/trains1.svg" alt="" />
						<p>累计预约次数</p>
						<span>{{ usersdatatj.TotalAppointmentCount }}</span>
					</div>

					<div class="trainschat2 flexx">
						<img src="@/images/trains2.svg" alt="" />
						<p>实训合格率</p>
						<span>{{ usersdatatj.PercentTrainScore }}%</span>
					</div>
					<div class="trainschat2 flexx">
						<img src="@/images/trains3.svg" alt="" />
						<p>累计实训时长</p>
						<span>{{ usersdatatj.TotalTrainTimeCount }} 分钟</span>
					</div>
				</div>
			</div>

			<div class="responstbilteall classdatatotle">
				<div class="trainstitle flexx">
					<span style="display: block;width: 6px;height: 20px;margin-right: 10px;border-radius: 2px;background-color: #58A3F7;"></span>
					<p style="font-size: 1.2rem;font-weight: 600;">综合能力评估</p>
				</div>
				<div class="rebuilctlis flexx" style="flex-wrap: wrap;">
					<div v-show="isrestbiltys == 0" class="rebuilctlischat" ref="rebuilctlischat" id="rebuilctlischat"></div>
					<div v-if="isrestbiltys == 1" style="width: 100%;margin: 0 auto;"><el-empty description="暂无能力评估记录,请进行实训"></el-empty></div>
					<div class="scoolct" style="width: 60%;overflow-x: scroll;" v-if="isrestbiltys == 0">
						<!-- <div class="rebuilctlistdataitme flexx" v-for="(item, index) in mytraindata" :key="item.projectTypeName">
							<div style="width: 20%;"><p class="cilcle">{{item.projectAVG}}</p></div>
							<div class="stdataitmefont">
								<p>{{item.projectTypeName}}</p>
								<div class="stdataitmecontent">总实训次数：{{item.projectSum}}次， 其中优秀 {{item.projectBest}} 次，良好 {{item.projectGood}} 次， 一般 {{item.projectGeneral}}次， 未掌握 {{item.projectNoEwaluating}} 次，未评测 {{item.projectNoFailing}} 次。</div>
							</div>
						</div> -->

						<el-carousel indicator-position="none" :autoplay="false" :loop="false">
							<el-carousel-item v-for="(item, index) in mytraindataall" :key="index">
								<div class="rebuilctlistdata flexx">
									<div class="rebuilctlistdataitme flexx" v-for="(ite, ind) in item" :key="ite.projectTypeName">
										<div style="width: 20%;">
											<p class="cilcle">{{ ite.projectAVG }}</p>
										</div>
										<div class="stdataitmefont">
											<p>{{ ite.projectTypeName }}</p>
											<div class="stdataitmecontent">
												总实训次数：{{ ite.projectSum }}次， 其中优秀 {{ ite.projectBest }} 次，良好 {{ ite.projectGood }} 次， 一般
												{{ ite.projectGeneral }}次， 未掌握 {{ ite.projectNoEvaluating }} 次，未评测 {{ ite.projectNoFailing }} 次。
											</div>
										</div>
									</div>
								</div>
							</el-carousel-item>
						</el-carousel>
					</div>
				</div>
			</div>

			<div class="responstbilteall classdatatotle">
				<div class="trainstitle flexx">
					<span style="display: block;width: 6px;height: 20px;margin-right: 10px;border-radius: 2px;background-color: #58A3F7;"></span>
					<p style="font-size: 1.2rem;font-weight: 600;">实训记录</p>
					<p style="margin-top: 7px;margin-left: 10px;color: #ccc;">
						共
						<span style="color: red;font-weight: 700;">{{ totalCounts }}</span>
						记录，本次记录最多只显示200条，具体详情请看预约记录查询页面
					</p>
				</div>
				<div class="classreabilctexr" id="classreabilctexr">
					<el-empty v-if="steplists.length == 0" description="暂无实训记录请通知学生尽快完成实训"></el-empty>
					<starpes :dataArray="steplists"></starpes>
					<div @click="stapchangepages" class="staprelist" v-if="steaplistsall.length > steappagsize">查看更多</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';
import 'echarts/lib/chart/bar';

import starpes from '@/components/stapes.vue';

import html2canvas from 'html2canvas';


import domtoimage from 'dom-to-image';

import { scoollist } from '@/request/alllog.js';

import { getWeekDay, splitArray } from '@/utils/utils.js';

import { GetyyGetClassList } from '@/request/api/dataorder/dataprder.js';

import { getMyTrainResults } from '@/request/api/userapi/studenthome.js';

import { getmytraindata, GetdataClassStuinfoList, getGetTrainlogList } from '@/request/api/pingtai/trainsplan.js';

import { GetyyTrainEquipmentList } from '@/request/api/dataorder/dataprder';
import { getUserSingle } from '@/request/api/mange/mange.js';
import { GetMyTrainDataApi, GetMyTrainResultsApi } from '@/request/api/homesview/yunhomes/yunhom';
import AppOptions from '@/config/AppOptions.vue';
import $ from 'jquery';
export default {
	data() {
		return {
			// 打印
			printsobj: {
				id: 'pdf-container',
				popTitle: '学员实训档案', // 打印配置页上方标题
				extraHead: '', //最上方的头部文字，附加在head标签上的额外标签,使用逗号分隔
				preview: false, // 是否启动预览模式，默认是false（开启预览模式，可以先预览后打印）
				extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>,<style> #pdf-container { height: auto !important; } <style>' //  可以传进去  style tag 标签；注意要逗号分隔   解决特定区域不显示问题；
			},

			ispdfs: true,
			// 步骤条

			isactives: 1,
			// 标题
			paths: [
				{
					path: '/usercenter/usermanage/trainingpracticalusers',
					name: '我的实训档案'
				}
			],
			// 下拉列表
			options: [],
			usersvalue: localStorage.getItem('uiguid'),
			classnameinput: '',
			// 综合能力评估
			responstbilteoption: {
				tooltip: {
					trigger: 'axis'
				},
				radar: {
					// shape: 'circle',
					indicator: [],
					splitArea: {
						show: true,
						areaStyle: {
							color: ['rgba(157,200,241,0.1)', 'rgba(157,200,241,0.3)', 'rgba(157,200,241,0.1)', 'rgba(157,200,241,0.3)']
						}
					},
					splitLine: {
						lineStyle: {
							color: '#ccc'
						}
					},
					axisLine: {
						lineStyle: {
							width: 1,
							color: '#ccc'
						}
					}
				},

				series: [
					{
						name: '能力统计',
						type: 'radar',
						barWidth: null,
						itemStyle: {
							color: '#9DC8F1'
						},
						lineStyle: {
							color: '#9DC8F1'
						},
						areaStyle: {
							color: '#9DC8F1',
							opacity: 0.8
						},
						tooltip: {
							trigger: 'item'
						},
						data: [
							{
								value: [4200, 3000, 20000, 35000, 50000, 18000],
								name: '能力统计'
							}
						]
					}
				]
			},
			// 获取学员
			schoollists: [],
			schoolvalue: localStorage.getItem('siguid'),
			classnamelist: [],
			classvalue: '',
			usersobj: {},
			usersdatatj: {},
			// 获取实训统计能力评估
			mytraindata: [],
			responindicator: [],
			mytrainseries: [],
			trainslogpageSize: 200,
			trainslogpageIndex: 1,
			starpeslist: [],
			totalCounts: 0,
			steplists: [],
			steaplistsall: [],
			steappagsize: 10,
			mytraindataall: [],
			// 设备筛选
			stevalue: '',
			stenamelist: [],
			isrestbiltys: 0
		};
	},
	created() {
		AppOptions.appEmpty = false;
	},
	async mounted() {
		if (AppOptions.appEmpty) {
			// this.getresponstbilte();
			let homestop = $(this.$refs.homes).offset().top;
			let homesleft = $(this.$refs.homes).offset().left;
			if (homestop < 25 && localStorage.getItem('token') && homesleft < 200) {
				// console.log("刷新页面")
				// if (localStorage.getItem('token')) {
				// 	window.location.reload();
				// }
			}
		}
		await this.getstelist();
		await this.getusersge();
		window.addEventListener('scroll', this.handleScroll); // 监听页面滚动

		// this.getschoollist();
	},
	watch: {
		stevalue(val) {
			// console.log('更新设备', val);
			if (val) {
				this.getusersdataall();
				this.gettrainslog();
				this.getdatatrains();
			}
		}
	},
	methods: {
		// 获取设备
		getstelist() {
			GetyyTrainEquipmentList(this.schoolvalue).then(res => {
				// console.log('设备列表', res.data.data);
				this.stenamelist = res.data.data;
				if (this.stenamelist.length > 0) {
					this.stevalue = this.stenamelist[0].sx_te_guid;
				}
			});
		},
		// 获取当前用户
		getusersge() {
			// getUserSingle(this.usersvalue).then(res => {
			// 	this.usersobj = res.data.data;
			// });

			this.usersobj = JSON.parse(localStorage.getItem('userss'));

			// console.log(this.usersobj,'获取当前用户')
		},

		gettrainslog() {
			let trainslogobj = {
				ui_guid: this.usersvalue,
				pageIndex: this.trainslogpageIndex,
				pageSize: this.trainslogpageSize
			};
			getGetTrainlogList(trainslogobj).then(res => {
				// console.log(res,"获取res")
				if (res.data.data.list.length > 0) {
					this.starpeslist = res.data.data.list;
					this.totalCounts = res.data.data.totalCount;
					let starpeslist = [];
					this.starpeslist.forEach((item, index) => {
						starpeslist.push({
							transnemes: item,
							trainstimers: item[0].TDT_EndTime.slice(0, 10),
							trainstimerweek: getWeekDay(item[0].TDT_EndTime.slice(0, 10)),
							trainstimerweekstart: getWeekDay(item[0].TDT_StartTime.slice(0, 10))
						});
						item.forEach((ite, idx) => {
							ite.ids = 'd' + (idx + 1);
						});
					});

					starpeslist.forEach(item => {
						item.transnemes = item.transnemes.slice(0, 10);
						item.transallnems = item.transnemes;
					});
					this.steaplistsall = starpeslist;
					this.steplists = splitArray(starpeslist, this.steappagsize)[0];

					// console.log(this.steplists)
				} else {
					this.steplists = [];
				}
			});
		},
		stapchangepages() {
			this.steappagsize += 10;
			this.steplists = splitArray(this.steaplistsall, this.steappagsize)[0];
		},
		getdatatrains() {
			let traindataobj = {
				ui_guid: this.usersvalue,
				sx_te_guid: this.stevalue
			};
			GetMyTrainDataApi(traindataobj).then(res => {
				// console.log(res.data.data,"获取列表")
				if (res.data.data.length > 0) {
					this.isrestbiltys = 0;
					this.mytraindata = res.data.data;
					let mytrainseries = [];
					this.mytraindata.forEach(item => {
						mytrainseries.push(item.projectAVG);
					});
					this.mytrainseries = Math.max(...mytrainseries);

					let responindicator = [];

					this.mytraindata.forEach(item => {
						responindicator.push({
							name: item.projectTypeName,
							max: this.mytrainseries + 10
						});
					});
					// console.log("mytraindata》》》》》",this.mytraindata)
					this.mytraindataall = splitArray(this.mytraindata, 4);
					// console.log("mytraindataall》》》》》",this.mytraindataall)
					this.responstbilteoption.radar.indicator = responindicator;
					this.responstbilteoption.series[0].data[0].value = mytrainseries;

					let charts = document.getElementById('rebuilctlischat');

					let myCharts1 = this.$echarts.getInstanceByDom(charts);
					myCharts1 = this.$echarts.init(charts);

					this.myCharts1 = myCharts1;

					this.myCharts1.setOption(this.responstbilteoption);
				} else {
					this.isrestbiltys = 1;
				}
			});
		},

		// 获取院校列表
		getschoollist() {
			scoollist().then(res => {
				// console.log(res)
				if (res.data.data.length > 0) {
					this.schoollists = res.data.data;
					this.schoolvalue = res.data.data[0].si_guid;
					GetyyGetClassList(this.schoolvalue).then(rees => {
						this.classnamelist = rees.data.data;
						this.classvalue = rees.data.data[0].cla_guid;
						this.getclasstufo();
					});
				}
			});
		},
		getclasstufo() {
			let cllasobj = {
				cla_guid: this.classvalue,
				ui_realName: ''
			};
			GetdataClassStuinfoList(cllasobj).then(res => {
				if (res.data.data.length > 0) {
					this.options = res.data.data;
					this.usersvalue = res.data.data[0].ui_guid;
					this.usersobj = res.data.data[0];
					// this.getusersge()
				}
			});
		},
		getusersdataall() {
			if (this.usersvalue && this.stevalue) {
				GetMyTrainResultsApi({
					ui_guid: this.usersvalue,
					sx_te_guid: this.stevalue
				}).then(res => {
					// console.log("获取星系")
					if (res.data.code > 0) {
						// console.log(res.data.data,'这里有数据嘛')
						this.usersdatatj = res.data.data;
					} else {
						this.usersdatatj = res.data.data;
					}
				});
			}
		},
		getresponstbilte() {
			let charts = document.getElementById('rebuilctlischat');
			let myCharts1 = this.$echarts.getInstanceByDom(charts);
			myCharts1 = this.$echarts.init(charts);
			// console.log(myCharts1);
			myCharts1.setOption(this.responstbilteoption);
		},

		// 滚动
		// 获取页面滚动距离
		handleScroll() {
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			// console.log(scrollTop, '滚动距离');
			if (scrollTop < 200) {
				this.isactives = 1;
			} else if (scrollTop > 200 && scrollTop < 500) {
				this.isactives = 2;
			} else if (scrollTop > 500) {
				this.isactives = 3;
			}
		},
		// 滚动重置
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll);
		},
		changetablist(num) {
			this.isactives = num;

			if (num == 1) {
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				});
				// this.scrollToElement(this.$refs.scrollTotablists1);
			} else if (num == 2) {
				window.scrollTo({
					top: 400,
					behavior: 'smooth'
				});
				// this.scrollToElement(this.$refs.scrollTotablists2);
			} else {
				window.scrollTo({
					top: 840,
					behavior: 'smooth'
				});
				// this.scrollToElement(this.$refs.scrollTotablists3);
			}
		},
		scrollToElement(dom) {
			dom.scrollIntoView({ behavior: 'smooth', block: 'start' });
		},

		// 下载pdf
		downloadPDF(i) {
			this.ispdfs = false;
			const element = document.getElementById('pdf-container');

			// 将DOM元素转换为canvas
			// const canvas = ;
			// 将 DOM 元素转换为图像
			domtoimage
				.toPng(element)
				.then(dataUrl => {
					// 处理生成的图像数据 URL
					// console.log(dataUrl);
					if (i == 1) {
						//下载
						this.handleDownloadQrIMg(dataUrl);
					} else {
						// 打印
					}
					setTimeout(() => {
						this.ispdfs = true;
					}, 2000);
				})
				.catch(error => {
					// 处理转换过程中的错误
					this.$message('系统错误，正在反馈给技术人员');
					setTimeout(() => {
						this.$message.success('反馈成功，技术人员正在加急处理！');
						this.ispdfs = true;
					}, 2000);
					// console.error(error);
				});
		},
		handleDownloadQrIMg(qrBase64) {
			// 这里是获取到的图片base64编码,这里只是个例子哈，要自行编码图片替换这里才能测试看到效果
			const imgUrl = qrBase64;
			// 如果浏览器支持msSaveOrOpenBlob方法（也就是使用IE浏览器的时候），那么调用该方法去下载图片
			if (window.navigator.msSaveOrOpenBlob) {
				const bstr = atob(imgUrl.split(',')[1]);
				let n = bstr.length;
				const u8arr = new Uint8Array(n);
				while (n--) {
					u8arr[n] = bstr.charCodeAt(n);
				}
				const blob = new Blob([u8arr]);
				window.navigator.msSaveOrOpenBlob(blob, 'chart-download' + '.' + 'png');
			} else {
				// 这里就按照chrome等新版浏览器来处理
				const a = document.createElement('a');
				a.href = imgUrl;
				a.setAttribute('download', 'chart-download');
				a.click();
			}
		}
	},
	components: {
		titles,
		starpes
	}
};
</script>
